import React, {useState, useEffect, useRef, useCallback} from "react"
import { IxBaseRelationPopup } from 'components/relation-popup/base-relation-popup'
import { useTranslation } from 'react-i18next'

import client from 'api'

export const IxUserRepresentationActiveRelation = ({mainUserId, visiblePopup, setVisiblePopup}: any) => {
    const [availableData, setAvailableData] = useState<any>([])
    const [relatedData, setRelatedData] = useState<any>([])
    const [relatedMapData, setRelatedMapData] = useState<any>([])
    const [loading, setLoading] = useState(false)
    const [activeGrid, setActiveGrid] = useState<any>()
    const [mainUserInfo, setMainUserInfo] = useState<any>({})
    const availableGridRef = useRef(null)
    const relatedGridRef = useRef(null)
    const { t } = useTranslation()

    useEffect(() => {
        mainUserId && client.get(`api/ixweb/userdetails/?action=eql&user_id=${mainUserId}&fields=hdr_id,User_id,Username,Vorname,Nachname,Deaktiviert,Kreditorid,Niederlassung`).then((e: any) => {
            setMainUserInfo(e.data[0])
        })
    },[mainUserId])

    useEffect(() => {
        if (mainUserId) {
            let requests = 0
            let passedRequests = 0
            setLoading(true)
            client.get(`/api/ixweb/uservertretung/?action=gte&index_name=1&min_user_id=${mainUserId}&max_user_id=${mainUserId}&fields=hdr_id,User_id,Vertritt_user_id,nActiv`).then((e: any) => {
                setRelatedMapData(e.data)
                
                e.data.forEach((item: any) => {
                    requests ++
                    client.get(`api/ixweb/userdetails/?action=eql&user_id=${item.VERTRITT_USER_ID}&fields=hdr_id,User_id,Username,Vorname,Nachname,Deaktiviert,Kreditorid,Niederlassung`).then((res: any) => {
                        item.NACTIV ? setRelatedData((data: any) => ([...data, res.data[0]])) : setAvailableData((data: any) => ([...data, res.data[0]]))
                        passedRequests ++
                        if (passedRequests === requests) { setLoading(false) }
                    })
                })
            })
        }

    },[mainUserId])
    
    const onStoreData = useCallback(() => {
        let data = relatedMapData
        relatedData.forEach((relatedItem: any) => {
            const user = relatedMapData.find((relatedMapItem: any) => relatedItem.USER_ID === relatedMapItem.VERTRITT_USER_ID)
            if (!user.NACTIV) {
                client.put(`api/ixweb/uservertretung/${user.HDR_ID}/`, {'NACTIV': 1})
                .then (() => {
                    data = data.map((i: any) => (i.HDR_ID === user.HDR_ID) ? {...i, NACTIV: 1} : i)
                    setRelatedMapData(data)
                })
            }
        })

        availableData.forEach((availableItem: any) => {
            const user = relatedMapData.find((relatedMapItem: any) => availableItem.USER_ID === relatedMapItem.VERTRITT_USER_ID)
            if (user.NACTIV) {
                client.put(`api/ixweb/uservertretung/${user.HDR_ID}/`, {'NACTIV': 0})
                .then (() => {
                    data = data.map((i: any) => (i.HDR_ID === user.HDR_ID) ? {...i, NACTIV: 0} : i)
                    setRelatedMapData(data)
                })
            }
        })

    },[relatedMapData, relatedData, availableData])

    const filter = useCallback((values: any) => {
        const filter: any = {
            'all': () => { activeGrid && activeGrid.instance().clearFilter()},
            'active': () => {activeGrid && activeGrid.instance().filter(['!', ['DEAKTIVIERT']])},
            'deactivated': () => {activeGrid && activeGrid.instance().filter([['DEAKTIVIERT']])},
        }
        filter[values.userFilter]()
    },[activeGrid])

    return (
        <div>
            <IxBaseRelationPopup
                availableGridRef={availableGridRef}
                relatedGridRef={relatedGridRef}
                title={t('global:userRepresentationAvailable.title')}
                setActiveGrid={setActiveGrid}
                setVisiblePopup={setVisiblePopup}
                visible={visiblePopup}
                onStoreData={onStoreData}
                filter={filter}
                loading={loading}
                setRelatedData={setRelatedData}
                setAvailableData={setAvailableData}
                availableData={availableData}
                relatedData={relatedData}
                infoText={t('global:userRepresentationAvailable.infoText', {mainUserId: mainUserInfo.USER_ID, mainUserFirstName: mainUserInfo.VORNAME, mainUserSecondName: mainUserInfo.NACHNAME, mainUserName: mainUserInfo.USERNAME})}
                availableGridTitle={t('global:userRepresentationAvailable.availableGridTitle', {mainUserId: mainUserInfo.USER_ID})}
                relatedGridTitle={t('global:userRepresentationAvailable.relatedGridTitle', {mainUserId: mainUserInfo.USER_ID})}
                availableGridColumns={
                    [
                        {dataField: 'USER_ID', caption: t('global:relationBase.field.USER_ID')},
                        {dataField: 'USERNAME', caption: t('global:relationBase.field.USERNAME')},
                        {dataField: 'VORNAME', caption: t('global:relationBase.field.VORNAME')},
                        {dataField: 'NACHNAME', caption: t('global:relationBase.field.NACHNAME')},
                        {dataField: 'NIEDERLASSUNG', caption: t('global:relationBase.field.NIEDERLASSUNG')},
                        {dataField: 'VERWALTER', caption: t('global:relationBase.field.VERWALTER')},
                    ]
                }
                relatedGridColumns={
                    [
                        {dataField: 'USER_ID', caption: t('global:relationBase.field.USER_ID')},
                        {dataField: 'USERNAME', caption: t('global:relationBase.field.USERNAME')},
                        {dataField: 'VORNAME', caption: t('global:relationBase.field.VORNAME')},
                        {dataField: 'NACHNAME', caption: t('global:relationBase.field.NACHNAME')},
                        {dataField: 'NIEDERLASSUNG', caption: t('global:relationBase.field.NIEDERLASSUNG')},
                        {dataField: 'VERWALTER', caption: t('global:relationBase.field.VERWALTER')},
                    ]
                }
            />
        </div>
    )
}